import React from 'react';
import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseLeadPage,
  CarleadBannerTextHIWWhyChooseWkdaFaq,
  CarleadLicensePlateDefaultStep2
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadLicensePlateDefaultStep2}
      content={CarleadBannerTextHIWWhyChooseWkdaFaq}
      headlineDesktop='carleadCreation.form.title'
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
